import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { environment } from './../../../../../environments/environment';
import { ServiceCRUD } from './../../../../shared/crud/ServiceCRUD';

@Injectable({
  providedIn: 'root'
})
export class RelatorioKardexService extends ServiceCRUD {
  private baseUrlService: string
  
  recebeValor$: Observable<any>
  private valorEnvio = new Subject<any>();

  constructor(http: HttpClient, router: Router) {
    super(http, router)
    this.recebeValor$ = this.valorEnvio.asObservable();
    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return this.baseUrlService;
  }

  public setUrl(url){
    this.baseUrlService = environment.URL_API
    this.baseUrlService = `${this.baseUrlService}` + url;
  }

  public enviaValor(value: any) {
    this.valorEnvio.next(value);
  }
  
}
